import script from "./ClientBlockPageContacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientBlockPageContacts.vue?vue&type=script&setup=true&lang=ts"

import "./ClientBlockPageContacts.vue?vue&type=style&index=0&id=c34ff042&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c34ff042"]])

export default __exports__